import { LoginService } from './../../service/login.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormGroup } from '@angular/forms';
import { error } from '@angular/compiler/src/util';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm:FormGroup;
email:string;visibility:any;
type:any;
password:string;
  constructor(private route:Router,
    private loginService:LoginService) {
      this.visibility="visibility"
      this.type="text";
     }
  ngOnInit(): void {
  }

  changeVisibility(event)
  {
    console.log(event)
    if(event=='visibility')
    {
      this.type="password"
      this.visibility="visibility_off"
    }
    else if((event=='visibility_off'))
    {
      this.type="text"
      this.visibility="visibility"
    }
  }
 verify()
 {
   const user1=
   {
     "email":this.email,
     "password":this.password
   }
      this.loginService.verifyUser(user1).then(()=>
      {
        console.log("hi")
        this.route.navigate(['dashboard']);
       
      })
   
 }

  forget()
  {
    this.route.navigateByUrl('/forgetPassword')
  }

  dashboard()
  {
    this.route.navigateByUrl('/dashboard')
  }
  change()
  {
    
    this.route.navigateByUrl('/changePassword')
  }
}
